import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ path, alt = "", ...props }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) return undefined;
    let url;
    let active = true;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        if (!active) return;
        url = URL.createObjectURL(r.data);
        setSrc(url);
      })
      .catch(() => {});
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!src) return <div aria-hidden {...props} />;
  return <img src={src} alt={alt} {...props} />;
};
